import { restClient } from '../../client';


export enum ProviderStripeConnectStatus {
  notStarted = 'not_started',
  inProgress = 'in_progress',
  inReview = 'in_review',
  completed = 'completed',
  needsUpdating = 'needs_updating',
}


export const getProviderStripeConnectDetails = async (providerId: string) =>
  restClient.request<{
    data: {
      provider_id: string;
      status: ProviderStripeConnectStatus;
      updated_at: string;
    };
  }>(`/api/v1/stripe_connect_account/by_provider_id/${providerId}`, {
    method: 'GET',
  });

export const getProviderStripeConnectProfileLink = async (providerId: string) =>
  restClient.request<{
    data: string;
  }>(`/api/v1/stripe_connect_account/${providerId}/profile_link`, {
    method: 'GET',
  });
